import { Link } from 'react-router-dom';
import { ROUTES } from '@/config/routes';

interface LogoProps {
  className?: string;
  variant?: 'full' | 'icon';
}

export const Logo = ({ className = '', variant = 'full' }: LogoProps) => {
  return (
    <Link to={ROUTES.HOME} className={`group flex items-center gap-2 ${className}`}>
      {/* Icon/Symbol */}
      <div className="flex h-8 w-8 items-center justify-center rounded-xl bg-gray-800 transition-shadow duration-300 group-hover:shadow-glow-violet dark:bg-gradient-to-br dark:from-violet-500 dark:to-cyan-400">
        <span className="text-lg font-bold text-white">α</span>
      </div>

      {/* Full text logo */}
      {variant === 'full' && (
        <span className="font-display text-lg font-semibold tracking-tight text-gray-900 dark:text-white">
          Alpha
        </span>
      )}
    </Link>
  );
};
